import React, { useEffect, useState } from "react"
import { ToastContainer, toast } from "react-toastify"
import Select from "react-select"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import { withRouter } from "react-router-dom"
import PropTypes from "prop-types"
//i18n
import { withTranslation } from "react-i18next"
//Import Date Picker
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import APIS from "../../apis"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form, Input,
  Label,
  Row,
  Spinner,
} from "reactstrap"
import getDay from "date-fns/getDay"


const EditAvisRattrapage = props => {
  var userAuthEnseignant = JSON.parse(
    localStorage.getItem("userAuthEnseignant")
  )
  var enseignant_id = userAuthEnseignant.user.enseignant_id
  var annee_id = userAuthEnseignant.user.annee_id
  //
  const [date, setDate] = useState(new Date())
  const [quart, setQuart] = useState([])
  const [selectQuart, setSelectQuart] = useState("")
  const [type, setType] = useState([])
  const [selectType, setSelectType] = useState([])
  const [groupe, setGroupe] = useState([])
  const [selectGroupe, setSelectGroupe] = useState("")
  const [matiere, setMatiere] = useState([])
  const [selectMatiere, setSelectMatiere] = useState("")
  const [jourId, setJourId] = useState("")
  const [loading, setLoading] = useState(false)
  const [semestre, setSemestre] = useState([
    { value: 1, label: "Semestre 1" },
    { value: 2, label: "Semestre 2" },
  ])
  const [selectSemestre, setSelectSemestre] = useState("")
  const [tousEtudiant, setTousEtudiant] = useState(1)
  const [selectDisabled, setSelectDisabled] = useState(true);
  const [etudiant, setEtudiant] = useState([]);
  const [selectEtudiant, setSelectEtudiant] = useState("");
  useEffect(async () => {
    const resQ = await APIS.get("quart/select").then(resQ => {
      setQuart(resQ.data.Quart)
    })
    var url = window.location.href
    var array = url.split("=")
    var id = array[1]
    await APIS.post("avis/rattrapage/get_by_id", { id }).then(({ data }) => {
      const { date, quart, type, matiere, group, jour_id, semestre,etudiant ,type_seance} = data.rattrapage
      setDate(new Date(date))
      setSelectQuart(quart)
      setSelectType(type)
      setSelectMatiere(matiere)
      setSelectGroupe(group)
      setJourId(jour_id)
      setSelectSemestre(semestre)
      setSelectEtudiant(etudiant)
      if(type_seance == 1){
        setSelectDisabled(true)
      }else{
        setSelectDisabled(false)
      }
      setTousEtudiant(type_seance)
      setLoading(true)

      //get matiere
      APIS.post("emploi/get_matiere", {
        type: type.value,
        enseignant_id: enseignant_id,
        semestre_id: semestre.value,
        annee_id
      }).then(res => {
        setMatiere(res.data.matieres)
      })
      //get type
      APIS.post("emploi/get_type_matiere", {
        enseignant_id: enseignant_id,
        semestre_id: semestre.value,annee_id
      }).then(res => {
        setType(res.data.emploi)
      })
      // get group
      APIS.post("emploi/get_group", {
        quart_id: quart.value,
        jour_id: jour_id,
        quan: 0,
        matiere_id: matiere.value,
        type: type.value,
        enseignant_id: enseignant_id,
        semestre_id: semestre.value,annee_id
      }).then(resG => {
        setGroupe(resG.data.groups)
      })
      //get etudiant
      APIS.post("seance/list_etudiant_by_group_type_id_avis_rattrapage", {
        matiere_id: matiere.value,
        group_id: [group],
        type: type.value,
        quart_id: quart.value,
        jour_id: jour_id,
      }).then(resS => {
        setEtudiant(resS.data.Etudiant)
      })
    })

  }, [])

  const isWeekday = date => {
    const day = getDay(date)
    return day !== 0
  }

  const getQuart = e => {
    setSelectQuart(e)
    setSelectType("")
    setSelectMatiere("")
    setSelectGroupe("")
    setTousEtudiant(1)
    setSelectDisabled(true);
    setEtudiant([])
    setSelectEtudiant("")
  }

  const getDay1 = async e => {
    setDate(e)
    // convert date début
    let date = e
    let month = "" + (date.getMonth() + 1)
    let day = "" + date.getDate()
    let year = date.getFullYear()
    if (month.length < 2) month = "0" + month
    if (day.length < 2) day = "0" + day
    let convertDate = [year, month, day].join("-")
    const res = await APIS.post("quart/get_date", {
      date: convertDate,
    }).then(res => {
      setJourId(res.data.Date)
    })
  }

  const getTypeMatiere = async e => {
    setSelectSemestre(e)
    setDate(new Date())
    setSelectQuart("")
    setSelectType("")
    setSelectMatiere("")
    setSelectGroupe("")
    setTousEtudiant(1)
    setSelectEtudiant("")
    setEtudiant([])
    setSelectDisabled(true);
    const res = await APIS.post("emploi/get_type_matiere", {
      enseignant_id: enseignant_id,
      semestre_id: e.value,annee_id
    }).then(res => {
      setType(res.data.emploi)
    })
  }

  const getMatiere = async e => {
    setSelectType(e)
    setSelectMatiere("")
    setSelectGroupe("")
    const res = await APIS.post("emploi/get_matiere", {
      type: e.value,
      enseignant_id: enseignant_id,
      semestre_id: selectSemestre.value,annee_id
    }).then(res => {
      setMatiere(res.data.matieres)
    })
  }

  const getGroupe = async e => {
    setSelectMatiere(e)
    setSelectGroupe("")
    const resG = await APIS.post("emploi/get_group", {
      quart_id: selectQuart.value,
      jour_id: jourId,
      quan: 0,
      matiere_id: e.value,
      type: selectType.value,
      enseignant_id: enseignant_id,
      semestre_id: selectSemestre.value,annee_id
    }).then(resG => {
      setGroupe(resG.data.groups)
    })

    const resType = await APIS.post("seance/get_type_enseignement", {
      matiere_id: e.value,
    }).then(resType => {
      if(resType.data.type == 2){
        setTousEtudiant(2)
        setSelectDisabled(false);
      }else{
        setTousEtudiant(1)
        setSelectDisabled(true);
        setEtudiant([])
        setSelectEtudiant("")
      }

    })
  }

  const edit = async () => {
    var url = window.location.href
    var array = url.split("=")
    var id = array[1]
    // convert date début
    let dateRatt = date
    let month = "" + (dateRatt.getMonth() + 1)
    let day = "" + dateRatt.getDate()
    let year = dateRatt.getFullYear()
    if (month.length < 2) month = "0" + month
    if (day.length < 2) day = "0" + day
    let convertDate = [year, month, day].join("-")
    //
    if(selectEtudiant != ""){
      var etudiant_id=selectEtudiant.value
    }else{
      var etudiant_id=null
    }
    if (date == "") {
      toast.error("⛔ Dqte obligatoire !", {
        containerId: "A",
      })
    } else if (selectQuart == "") {
      toast.error("⛔ Quart obligatoire !", {
        containerId: "A",
      })
    } else if (selectType == "") {
      toast.error("⛔ Type obligatoire !", {
        containerId: "A",
      })
    } else if (selectMatiere == "") {
      toast.error("⛔ Matiere obligatoire !", {
        containerId: "A",
      })
    } else if (selectGroupe != "") {
      const res = await APIS.post("avis/rattrapage/edit", {
        id: id,
        date: convertDate,
        jour_id: jourId,
        quart_id: selectQuart.value,
        matiere_id: selectMatiere.value,
        group_id: [selectGroupe],
        type_id: selectType.value,
        enseignant_id: enseignant_id,
        semestre_id: selectSemestre.value,
        type_seance:tousEtudiant,
        etudiant_id:etudiant_id,
        annee_id,
      })
        .then(res => {
          props.history.push("/AvisRattrapage")
        })
        .catch(() => {
          toast.error("Problème lors de l'insertion !", {
            containerId: "A",
          })
        })
    } else {
      toast.error("⛔ Groupe obligatoire !", {
        containerId: "A",
      })
    }
  }
  const getSalle = async e => {
    setSelectGroupe(e)
    setSelectEtudiant("")
    setEtudiant([])
    APIS.post("seance/list_etudiant_by_group_type_id_avis_rattrapage", {
      matiere_id: selectMatiere.value,
      group_id: [e],
      type: selectType.value,
      quart_id: selectQuart.value,
      jour_id: jourId,
    }).then(resS => {
      setEtudiant(resS.data.Etudiant)
    })
  }
  return (
    <React.Fragment>
      <div className="page-content">
        {loading ? (
          <Container fluid>
            <Card>
              <CardBody>
                <CardTitle className="h4 mb-4" style={{ color: "#556EE6" }}>
                  {props.t("Modification")}
                </CardTitle>
                <Row>
                  <Form>
                    <Row>
                      <Col lg="6">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            {props.t("Semestre")}
                          </Label>
                          <Select
                            options={semestre}
                            isSearchable={true}
                            value={selectSemestre}
                            onChange={e => getTypeMatiere(e)}
                          />
                        </div>
                      </Col>
                      <Col lg="6">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            {props.t("Date")}
                          </Label>
                          <DatePicker
                            selected={date}
                            filterDate={isWeekday}
                            className="form-control ddate"
                            dateFormat="dd/MM/yyyy"
                            onChange={e => getDay1(e)}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            {props.t("Quart")}
                          </Label>
                          <Select
                            options={quart}
                            isSearchable={true}
                            value={selectQuart}
                            onChange={e => getQuart(e)}
                          />
                        </div>
                      </Col>
                      <Col lg="6">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">Type</Label>
                          <Select
                            options={type}
                            isSearchable={true}
                            value={selectType}
                            onChange={e => getMatiere(e)}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            Matiere
                          </Label>
                          <Select
                            options={matiere}
                            isSearchable={true}
                            value={selectMatiere}
                            onChange={e => getGroupe(e)}
                          />
                        </div>
                      </Col>
                      <Col md="6">
                        <div className="mb-3">
                          <Label className="d-block mb-3">Choix des groupes :</Label>
                          <div className="form-check form-check-inline">
                            <Input
                                type="radio"
                                id="customRadioInline1"
                                name="customRadioInline1"
                                className="form-check-input"
                                checked={tousEtudiant === 1}
                                disabled={true}
                                onChange={e => TousEtudiant(1)}
                            />
                            <Label
                                className="form-check-label"
                                htmlFor="customRadioInline1"
                            >
                              Groupe
                            </Label>
                          </div>
                          &nbsp;
                          <div className="form-check form-check-inline">
                            <Input
                                type="radio"
                                id="customRadioInline2"
                                name="customRadioInline1"
                                className="form-check-input"
                                checked={tousEtudiant === 2}
                                disabled={true}
                                onChange={e => filterEtudiant(2)}
                            />
                            <Label
                                className="form-check-label"
                                htmlFor="customRadioInline2"
                            >
                              Seule etudiant
                            </Label>
                          </div>
                        </div>
                      </Col>

                    </Row>
                    <Row>
                      <Col lg="6">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">Groupe</Label>
                          <Select
                              options={groupe}
                              isSearchable={true}
                              value={selectGroupe}
                              onChange={e => getSalle(e)}
                          />
                        </div>
                      </Col>
                      <Col lg="6">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">Etudiant</Label>
                          <Select
                              options={etudiant}
                              isSearchable={true}
                              value={selectEtudiant}
                              onChange={e => setSelectEtudiant(e)}
                              isDisabled={selectDisabled}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Form>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {" "}
                    <Col lg="6">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                        className="text-center mt-4"
                      >
                        <Button
                          type="button"
                          color="warning"
                          className="btn btn-warning  mb-2 me-2"
                          onClick={() => props.history.push("/AvisRattrapage")}
                        >
                          {props.t("Annuler")}
                        </Button>
                      </div>
                    </Col>
                    <Col lg="6">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                        className="text-center mt-4"
                      >
                        <button
                          type="button"
                          className="btn btn-primary "
                          onClick={edit}
                        >
                          {props.t("Confirmer")}
                        </button>
                      </div>
                    </Col>
                  </div>
                </Row>
              </CardBody>
            </Card>
            <ToastContainer
              transition={Slide}
              enableMultiContainer
              containerId={"A"}
              position={toast.POSITION.TOP_RIGHT}
              autoClose={2500}
            />
          </Container>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <Spinner type="grow" className="ms-6" color="primary" />
            </div>
            <h4
              style={{ textAlign: "center", marginTop: "2%" }}
              className="ms-6"
            >
              {props.t("Chargement en cours...")}
            </h4>
          </div>
        )}
      </div>
    </React.Fragment>
  )
}
export default withRouter(withTranslation()(EditAvisRattrapage))
EditAvisRattrapage.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
  t: PropTypes.any,
}
